import s from "react";
import { NewFooter as m } from "./components/NewFooter/NewFooter.js";
import { OldFooter as T } from "./components/OldFooter/OldFooter.js";
import { groupTabLinks as n } from "./utils/groupTabLinks.js";
var v = Object.defineProperty,
  w = Object.defineProperties,
  E = Object.getOwnPropertyDescriptors,
  i = Object.getOwnPropertySymbols,
  f = Object.prototype.hasOwnProperty,
  b = Object.prototype.propertyIsEnumerable,
  p = (r, e, t) => e in r ? v(r, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : r[e] = t,
  l = (r, e) => {
    for (var t in e || (e = {})) f.call(e, t) && p(r, t, e[t]);
    if (i) for (var t of i(e)) b.call(e, t) && p(r, t, e[t]);
    return r;
  },
  y = (r, e) => w(r, E(e)),
  S = (r, e) => {
    var t = {};
    for (var o in r) f.call(r, o) && e.indexOf(o) < 0 && (t[o] = r[o]);
    if (r != null && i) for (var o of i(r)) e.indexOf(o) < 0 && b.call(r, o) && (t[o] = r[o]);
    return t;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const u = r => {
  var e = r,
    {
      firstTabLinks: t,
      secondTabLinks: o,
      thirdTabLinks: c,
      fourthTabLinks: d
    } = e,
    a = S(e, ["firstTabLinks", "secondTabLinks", "thirdTabLinks", "fourthTabLinks"]);
  const _ = n(t),
    L = n(o),
    O = n(c),
    k = n(d);
  return a.newFooter ? s.createElement(m, y(l({}, a), {
    firstGroupTabLinks: _,
    secondGroupTabLinks: L,
    thirdGroupTabLinks: O,
    fourthGroupTabLinks: k
  })) : s.createElement(T, l({}, a));
};
export { u as Footer, u as default };